import axios from 'axios';

export const baseUrl = String(process.env.REACT_APP_API_URL);

window._isUnauthorizedHandled = window._isUnauthorizedHandled ?? false;

const onFulfilled = async (response) => {
  return response;
};

const onRejected = async (error) => {
  console.error('Axios request failed:', error);

  // Check if the error has a response and if the status is 401 (Unauthorized)
  if (error.response && error.response.status === 401) {
    if (!window._isUnauthorizedHandled) {
      window._isUnauthorizedHandled = true;
      localStorage.clear();
      sessionStorage.clear();

      if (window.caches?.keys) {
        window.caches.keys().then(function clearCacheNames(names) {
          names.forEach((name) => window.caches.delete(name));
        });
      }

      localStorage.setItem('REDIRECT_AFTER_LOGIN', window.location.pathname);
      localStorage.setItem(
        '__error',
        JSON.stringify({
          status: error.response.status,
          message: error.message,
          request_data: error.response.config?.data ?? null,
          response_data: error.response.data,
        }),
      );
      localStorage.setItem('SESSION_EXPIRED', 'true');
      window.location.replace(process.env.REACT_APP_HOME_URL);
    }
  }
  error._ignoreError = true;
  return Promise.reject(error);
};

axios.defaults.withCredentials = true;
axios.defaults.timeout = 60000; // 60 seconds timeout

axios.interceptors.response.use(onFulfilled, onRejected);

const api = axios.create({
  withCredentials: true,
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Credentials': 'true',
    Accept: '*/*',
    'Cache-Control': 'no-cache',
  },
  credentials: 'include',
});

api.interceptors.response.use(onFulfilled, onRejected);
window._api = api;

export default api;
